import { render, staticRenderFns } from "./AuthRegisterWithNpiForm.vue?vue&type=template&id=36a6ca0d&scoped=true"
import script from "./AuthRegisterWithNpiForm.vue?vue&type=script&lang=js"
export * from "./AuthRegisterWithNpiForm.vue?vue&type=script&lang=js"
import style0 from "./AuthRegisterWithNpiForm.vue?vue&type=style&index=0&id=36a6ca0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6ca0d",
  null
  
)

export default component.exports